import { useVisitsHistoryTab } from '@app/components/RecordModal/components/VisitsHistoryTab/hooks';
import type { ContentPropsType } from '@app/components/RecordModal/types';
import { VisitsHistory } from '@app/components/VisitsHistory';

export const VisitsHistoryTab: ContentPropsType = () => {
  const { clientId } = useVisitsHistoryTab();

  return <VisitsHistory clientId={clientId} />;
};
